var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"tab-show"},_vm._l((_vm.tabbar),function(item,index){return _c('div',{key:index,staticClass:"tab-tr",class:_vm.showIndex==index?'show-tr':'',on:{"click":function($event){return _vm.showTab(item)}}},[_vm._v(_vm._s(item.name)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-448e294c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/switchTabbar/switchHallTabbar.vue
// module id = null
// module chunks = 